import { PortableTextComponents } from '@portabletext/react';
import FormattedLink from '@/components/FormattedLink';

export const portableTextComponents: PortableTextComponents = {
    block: {
        h1: ({ children }) => (
            <h1 className="text-3xl sm:text-5xl mb-2">{children}</h1>
        ),
        blockquote: ({ children }) => (
            <blockquote className="border-l-4 border-l-green-500 pl-4 mb-2 italic">
                {children}
            </blockquote>
        ),
        // Sanity uses 'normal' for standard paragraphs, not 'span'
        normal: ({ children }) => <p className="mb-2">{children}</p>,
    },
    list: {
        bullet: ({ children }) => (
            <ul className="list-disc mb-2 pl-6">{children}</ul>
        ),
        number: ({ children }) => (
            <ol className="list-decimal mb-2 pl-6">{children}</ol>
        ),
    },
    marks: {
        link: ({ children, value }) => {
            const href = value?.href || '';
            const isExternal = href.startsWith('http');

            return (
                <FormattedLink
                    url={href}
                    isExternalUrl={isExternal}
                    className="text-brand hover:text-brand/80 underline"
                >
                    {children}
                </FormattedLink>
            );
        },
    },
};
